// Google Analytics 4 (gtag.js).
// The dataLayer queue and the `config` command (which sends the page view) are in the server HTML,
// so the visit is recorded with its original timestamp; gtag.js itself (~170 KB) is injected after
// the window load event, when the browser is idle, so it never competes with the page for the
// network or the main thread. gtag.js replays the queued commands when it arrives.
// Page changes after that are client-side navigations; GA4's enhanced measurement
// ("page changes based on browser history events", on by default) records them as page views.
// Skipped in dev so local traffic stays out of the reports.
export default defineNuxtPlugin(() => {
  const id = useRuntimeConfig().public.gaId as string
  if (import.meta.dev || !id) return

  const src = `https://www.googletagmanager.com/gtag/js?id=${id}`
  useHead({
    script: [
      {
        innerHTML:
          `window.dataLayer=window.dataLayer||[];function gtag(){dataLayer.push(arguments);}gtag('js',new Date());gtag('config','${id}');` +
          `(function(){function l(){var s=document.createElement('script');s.async=true;s.src='${src}';document.head.appendChild(s)}` +
          `function i(){'requestIdleCallback' in window?requestIdleCallback(l,{timeout:5000}):setTimeout(l,1500)}` +
          `document.readyState==='complete'?i():addEventListener('load',i,{once:true})})();`,
      },
    ],
    link: [{ rel: 'dns-prefetch', href: 'https://www.googletagmanager.com' }],
  })
})
